import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import Grid, {GridProps} from "@mui/material/Grid"

const Props = styled((props: GridProps) => (
	<Grid container direction="column" width="100%" paddingRight="0px" {...props} />
))``

const Prop = styled((props: GridProps) => (
	<Grid container direction="row" width="100%" paddingRight="0px" {...props} />
))`
	* {
		width: 50%;
		padding: ${(props) => props.theme.spacing(1)};
	}
`

const PropLabel = styled(Typography)`
	text-align: end;
`

const PropValue = styled(Typography)`
	text-align: start;
`

export {Props, Prop, PropLabel, PropValue}
